// ═══════════════════════════════════════════════════════════════════════════════
// Skeleton Loading Components
// Modern loading UI for async data
// ═══════════════════════════════════════════════════════════════════════════════

import { cn } from '@/lib/utils';
import { Card } from '@/components/ui/card';

interface SkeletonCardProps {
  className?: string;
}

export function SkeletonCard({ className }: SkeletonCardProps): JSX.Element {
  return (
    <Card className={cn('p-6 animate-pulse', className)}>
      <div className="h-4 bg-muted rounded w-1/3 mb-4" />
      <div className="h-8 bg-muted rounded w-1/2 mb-2" />
      <div className="h-3 bg-muted rounded w-2/3" />
    </Card>
  );
}

export function SkeletonStats(): JSX.Element {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {[...Array(4)].map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}

export function SkeletonChart(): JSX.Element {
  return (
    <Card className="p-6 animate-pulse">
      <div className="h-4 bg-muted rounded w-1/4 mb-4" />
      <div className="h-64 bg-muted rounded" />
    </Card>
  );
}
